var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseHowl',{ref:"howl",attrs:{"url":require('@/assets/audio/lobby-music.mp3'),"loop":true}})}
var staticRenderFns = []

export { render, staticRenderFns }